import apiFetch from '../apiFetch'

export default function (idCliente) {
  return apiFetch({endPoint: `Combos/getDireccionesCliente?idCliente=${idCliente}`, method: 'GET'})
}
